import { styled } from '@uhg-abyss/web/tools/styled';

/**
 * App-level style wrapper for Abyss v2 overrides that CANNOT live in the theme.
 *
 * Brand color overrides for components (nav bar, DataTable headers, banner
 * header) live in theme/brandOverrides.ts as component-token overrides — that is
 * the recommended v2 approach. Only keep overrides here when they must be
 * SCOPED to a selector (to avoid global impact) or when they change behavior
 * rather than a token value.
 */
export const Styles = styled('div', {
  // v1 banner header had a subtle drop shadow; v2 sets none. The white
  // background is handled by the `header.color.surface.header-container` theme
  // override — only the shadow (a plain, non-token rule) needs to live here.
  '.abyss-header-root': {
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 2px 0px',
  },

  // v1 Table (V1Table) headers read GENERIC semantic tokens (surface tertiary /
  // neutral 95), which are shared app-wide — so they can't be recolored in the
  // theme without affecting other surfaces. Scope the CSS-variable override to
  // the header cells instead. (Custom-property values must stay in raw `var()`
  // form: the `$token` resolver can't infer a type from a custom-property key.)
  //
  // The remaps below cover the auto-generated header (its bg reads
  // surface-tertiary and its text container reads neutral-95). The manual
  // `<Table.Column>` API renders a header cell with NO backgroundColor of its
  // own, so it needs the brand navy/white set DIRECTLY as well.
  '.abyss-table-styled-header': {
    '--abyss-colors-web-semantic-color-surface-container-tertiary':
      'var(--abyss-colors-web-semantic-color-surface-container-primary)',
    '--abyss-colors-core-color-neutral-95':
      'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
    backgroundColor:
      'var(--abyss-colors-web-semantic-color-surface-container-primary)',
    color: 'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
  },

  // v1 underlined nav links on hover. v2 only underlines the `selected` link
  // and hardcodes `text-decoration: none !important` on the anchor, so restore
  // the hover underline here (a :hover selector out-specifies the base rule).
  // This is a behavioral override, not a token, so it belongs here.
  '.abyss-nav-menu-link:hover': {
    textDecoration: 'underline !important',
  },
});
